export default __webpack_public_path__ + "static/media/ChinaTown.36fc52b1.jpg";